import React, { useState, useEffect } from 'react';
import ApiService from '../services/api'; // Make sure path is correct
import {
    MonitorCog , SquareActivity , Tickets,Receipt , Briefcase,
    Menu,
    X,
    Home,
    Package,
    FileText,
    Calendar,
    Users,
    BarChart3,
    Settings,
    Bell,
    Search,
    ChevronDown,
    ArrowRight,
    TrendingUp,
    TrendingDown,
    Building,
    Hammer,
    Truck,
    Star,
    AlertCircle,
    CheckCircle,
    Clock,
    DollarSign,
    Activity,
    Globe,
    Zap,
    Target,
    Award,
    Shield,
    LogOut,
    ChevronRight,
    Filter,
    Download,
    RefreshCw,
    MoreVertical,
    Plus,
    User,
    Edit,
    Trash2,
    Eye,
    Package2,
    Layers,
    Wrench,
    ShoppingCart,
    Box,
    Hash,
    QrCode,
    Scan,
    Database,
    Copy,
    ExternalLink,
    BarChart2,
    Grid3X3,
    Cable,
    UserCog,
    Calculator,
    Construction,
    Beaker,
    Leaf,
    ShieldCheck,
    Folder
} from 'lucide-react';
import '../Styles/products.css'; // Reusing the same CSS
import { useNavigate } from 'react-router-dom';
import MepIcon from '../assets/MEP_Solutions.png';
import architecturalIcon from '../assets/architectural_icon.png';
import civilIcon from '../assets/civil-icon.png';
import constructionIcon from '../assets/construction-icon.png';
import powerToolsIcon from '../assets/power-tools_icon.png';
import sustainableIcon from '../assets/sustainable-icon.png';
import hygienicIcon from '../assets/hygienic-icon.png';
import '../Styles/dashboard.css';
import * as XLSX from 'xlsx';

const UnitechBarcodingPage = () => {
    const [user, setUser] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('barcoding');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [isLoading, setIsLoading] = useState(false);
    const [selectedPhase, setSelectedPhase] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('createdAt');
    const [sortOrder, setSortOrder] = useState('desc');
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedBarcode, setSelectedBarcode] = useState(null);
    const navigate = useNavigate();
    const [showStatsModal, setShowStatsModal] = useState(false);
    const [detailedStats, setDetailedStats] = useState(null);
    const [statsLoading, setStatsLoading] = useState(false);

    const [notifications, setNotifications] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: '',
        message: '',
        onConfirm: null
    });
    
    // Dynamic data from API
    const [barcodes, setBarcodes] = useState([]);
    const [phaseStats, setPhaseStats] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0,
        limit: 30 
    });
    const [error, setError] = useState(null);

    const getCategoryDisplayName = (category) => {
        const categoryMap = {
            'cable_trays_accessories': 'Cable Trays & Accessories',
            'frp_cable_tray': 'FiberGlass Reinforced Plastic FRP Cable Tray/Ladder',
            'cable_ladders': 'Cable Ladders (Welded & Swaged)',
            'cable_trunkings': 'Cable Trunkings',
            'underfloor_trunkings': 'Underfloor Trunkings',
            'weatherproof_cable_trunk': 'Weatherproof Cable Trunk',
            'cable_management_support': 'Cable Management Support Systems',
            'basket_trays_accessories': 'Basket Trays & Accessories',
            'stair_nosing': 'Stair Nosing',
            'tape': 'Tape',
            'skirting': 'Skirting',
            'movement_joints': 'Movement Joints',
            'channel_strips': 'Channel Strips',
            'landscaping': 'Landscaping',
            'tactile': 'Tactile',
            'rubber_gasket': 'Rubber Gasket',
            'entrance_matting_system': 'Entrance Matting System',
            'expansion_joints': 'Expansion Joints',
            'fire_barrier': 'Fire Barrier',
            'ferox_access_panels': 'Ferox Access Panels',
            'ferox_steel_doors': 'Ferox Steel Doors',
            'pipe_clamps_hangers': 'Pipe Clamps & Hangers',
            'threaded_accessoris_pipe_clamps': 'Threaded Accessories & Pipe Clamps',
            'c_channel_runs': 'C-Channel Runs',
            'toothed_channels': 'Toothed Channels',
            'c_channel_fittings': 'C-Channel Fittings',
            'c_channel_accessories': 'C-Channel Accessories',
            'c_channel_anchors': 'C-Channel Anchors',
            'cable_fastenning_system': 'Cable Fastening System',
            'galvanized_threaded_rods': 'Galvanized Threaded Rods',
            'metal_ceiling_grid_system': 'Metal Ceiling Grid System',
            'gfrp': 'Glass Fiber Reinforced Plastic (GFRP)',
            'phenolic_partition_systems': 'Phenolic Partition Systems',
            'paints': 'Paints'
        };
        
        return categoryMap[category] || category.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    };

    // Modal state for adding new barcode
    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        product: '',
        codeEAN13: '',
        barcodeStatus: 'Available',
        productName: '',
        phase: 'initial',
        brand: '',
        category: '',
        location: '',
        assignedTo: '',
        notes: '',
        description: ''
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Fonction pour créer une notification
    const showNotification = (message, type = 'success', duration = 4000) => {
        const id = Date.now() + Math.random();
        const notification = { id, message, type, duration };
        setNotifications(prev => [...prev, notification]);
        setTimeout(() => removeNotification(id), duration);
    };

    // Fonction pour supprimer une notification
    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(notif => notif.id !== id));
    };

    // Fonction helper pour les confirmations
    const showConfirmDialog = (title, message, onConfirm) => {
        setConfirmDialog({ isOpen: true, title, message, onConfirm });
    };

    const closeConfirmDialog = () => {
        setConfirmDialog({ isOpen: false, title: '', message: '', onConfirm: null });
    };

    // Load user data on mount
    useEffect(() => {
        loadCurrentUser();
    }, []);

    // Load initial data
    useEffect(() => {
        if (user) {
            loadPhaseStats();
            loadBarcodes();
        }
    }, [user]);

    // Load barcodes when filters change
    useEffect(() => {
        if (user) {
            const timeoutId = setTimeout(() => {
                // Reset to page 1 when search/filter changes, mais seulement si on n'est pas déjà sur la page 1
                if (pagination.page !== 1) {
                    setPagination(prev => ({ ...prev, page: 1 }));
                } else {
                    // Si on est déjà sur la page 1, charger directement
                    loadBarcodes();
                }
            }, 500); // 500ms debounce

            return () => clearTimeout(timeoutId);
        }
    }, [selectedPhase, searchTerm, sortBy, sortOrder, user]);

    // Ajouter un useEffect séparé pour charger quand la page change
    useEffect(() => {
        if (user && pagination.page) {
            loadBarcodes();
        }
    }, [pagination.page, user]);

    // Time update effect
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    // FIXED: Better user loading that doesn't redirect unnecessarily
const loadCurrentUser = async () => {
    try {
        // Check sync user first (instant)
        const syncUser = ApiService.getUserSync();
        if (syncUser) {
            setUser(syncUser);
            return;
        }

        // Only check server if no user in memory/storage
        console.log('No sync user, checking authentication...');
        const response = await ApiService.getCurrentUser();
        
        if (response.success && response.user) {
            setUser(response.user);
        } else if (response.needsLogin) {
            // Clear any stale data and redirect
            ApiService.clearUserData();
            navigate('/login');
        } else {
            console.log('No valid session, redirecting to login...');
            navigate('/login');
        }
    } catch (error) {
        console.error('Failed to load user:', error);
        // Only redirect if we have no user data at all
        if (!ApiService.getUserSync()) {
            navigate('/login');
        }
    }
};

    const loadDetailedStats = async () => {
        setStatsLoading(true);
        try {
            const response = await ApiService.getDetailedBarcodeStats();
            if (response.success) {
                setDetailedStats(response.stats);
            } else {
                throw new Error(response.message || 'Failed to load statistics');
            }
        } catch (error) {
            console.error('Failed to load detailed stats:', error);
            showNotification('Failed to load statistics: ' + error.message, 'error');
        } finally {
            setStatsLoading(false);
        }
    };

    const openStatsModal = () => {
        setShowStatsModal(true);
        loadDetailedStats();
    };

    const closeStatsModal = () => {
        setShowStatsModal(false);
        setDetailedStats(null);
    };

    const loadPhaseStats = async () => {
        try {
            const response = await ApiService.getBarcodePhaseStats();
            if (response.success) {
                setPhaseStats(response.phases);
            }
        } catch (error) {
            console.error('Failed to load phase stats:', error);
            // Fallback to static phases
            setPhaseStats([
                { id: 'all', name: 'Tous les codes-barres', count: 0, color: '#1e40af' },
                { id: 'initial', name: 'Phase Initiale', count: 0, color: '#059669' },
                { id: 'phase2', name: 'Phase 2', count: 0, color: '#dc2626' }
            ]);
        }
    };

const loadBarcodes = async () => {
    try {
        setIsLoading(true);
        setError(null);
        
        const params = {
            phase: selectedPhase !== 'all' ? selectedPhase : undefined,
            search: searchTerm.trim() || undefined,
            sortBy,
            sortOrder,
            page: pagination.page,
            limit: pagination.limit
        };

        // Remove undefined values
        Object.keys(params).forEach(key => {
            if (params[key] === undefined) {
                delete params[key];
            }
        });

        const response = await ApiService.getBarcodes(params);
        
        // Handle session expiry
        if (response.needsLogin) {
            console.log('Session expired, redirecting to login...');
            navigate('/login');
            return;
        }
        
        if (response.success) {
            setBarcodes(response.barcodes || []);
            setPagination(prev => ({
                ...prev,
                page: response.page || 1,
                pages: response.pages || 1,
                total: response.total || 0
            }));
        } else {
            throw new Error(response.message || 'Failed to fetch barcodes');
        }
    } catch (error) {
        console.error('Failed to load barcodes:', error);
        setError('Failed to load barcodes: ' + error.message);
        setBarcodes([]);
        setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
    } finally {
        setIsLoading(false);
    }
};

    const handleRefresh = () => {
        loadBarcodes();
        loadPhaseStats();
    };

    // Modal functions
    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            product: '',
            codeEAN13: '',
            barcodeStatus: 'Available',  // ← Changed
            productName: '',
            phase: 'initial',
            brand: '',
            category: '',
            location: '',
            assignedTo: '',
            notes: '',
            description: ''
        });
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let updatedFormData = {
            ...formData,
            [name]: value
        };

        if (name === 'phase') {
            if (value === 'phase2') {
                updatedFormData.brand = '';
            } else if (value === 'initial') {
                updatedFormData.category = '';
            }
        }

        setFormData(updatedFormData);
    };

    const handleAddBarcode = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.codeEAN13 || !formData.productName || !formData.product) {
                throw new Error('Please fill in all required fields (Product, EAN13 Code, Product Name)');
            }

            if (!/^\d{13}$/.test(formData.codeEAN13)) {
                throw new Error('The EAN13 code must contain exactly 13 digits');
            }

            if (formData.phase === 'phase2' && !formData.category) {
                throw new Error('The category is required for Phase 2');
            }

            if (formData.phase === 'initial' && !formData.brand) {
                throw new Error('The brand is required for Initial Phase');
            }

            const cleanFormData = { ...formData };

            if (cleanFormData.phase === 'phase2') {
                delete cleanFormData.brand; // Don't send brand for phase2
            } else if (cleanFormData.phase === 'initial') {
                delete cleanFormData.category; // Don't send category for initial
            }

            const response = await ApiService.createBarcode(cleanFormData);

            if (response.success) {
                showNotification('Barcode created successfully! 🎉', 'success');
                closeAddModal();
                loadBarcodes();
                loadPhaseStats();
            }
        } catch (error) {
            console.error('Error creating barcode:', error);
            setFormError(error.message || 'Error creating barcode');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteBarcode = async (barcodeId) => {
        showConfirmDialog(
            'Delete Barcode',
            'Are you sure you want to delete this barcode? This action is irreversible.',
            async () => {
                try {
                    setIsLoading(true);
                    const response = await ApiService.deleteBarcode(barcodeId);
                    if (response.success) {
                        loadBarcodes();
                        loadPhaseStats();
                        showNotification('Barcode deleted successfully', 'success'); // ← Changement ici
                    }
                } catch (error) {
                    console.error('Failed to delete barcode:', error);
                    showNotification('Error deleting barcode: ' + error.message, 'error'); // ← Changement ici
                } finally {
                    setIsLoading(false);
                    closeConfirmDialog();
                }
            }
        );
    };

    // Add this method in your barcoding component
const refreshSession = async () => {
    try {
        await ApiService.getCurrentUser();
    } catch (error) {
        console.log('Session refresh failed');
    }
};

// Call it periodically
useEffect(() => {
    const sessionRefreshInterval = setInterval(refreshSession, 30 * 60 * 1000); // Every 30 minutes
    return () => clearInterval(sessionRefreshInterval);
}, []);
const handleLogout = async () => {
    showConfirmDialog(
        'Logout',
        'Are you sure you want to log out?',
        async () => {
            try {
                await ApiService.logout(); // ApiService.logout() handles the redirect
            } catch (error) {
                console.error('Logout failed:', error);
                navigate('/login'); // Use navigate instead
            }
            closeConfirmDialog();
        }
    );
};

// Add this new function after handleEditBarcode
    const handleExportBarcodes = async () => {
        try {
            setIsLoading(true);
            showNotification('Preparing export...', 'info', 2000);

            // Prepare export parameters
            const exportParams = {
                phase: selectedPhase !== 'all' ? selectedPhase : undefined,
                search: searchTerm.trim() || undefined,
                sortBy,
                sortOrder,
                export: true, // Flag to get all data, not paginated
                limit: 10000 // Get maximum records for export
            };

            // Remove undefined values
            Object.keys(exportParams).forEach(key => {
                if (exportParams[key] === undefined) {
                    delete exportParams[key];
                }
            });

            // Get all barcodes for export
            const response = await ApiService.getBarcodes(exportParams);

            if (response.success && response.barcodes) {
                const barcodesToExport = response.barcodes;

                // Prepare data for export
                const exportData = barcodesToExport.map((barcode, index) => ({
                    'No.': index + 1,
                    'EAN13 Code': barcode.codeEAN13 || '',
                    'Product Reference': barcode.product || '',
                    'Product Name': barcode.productName || '',
                    'Phase': getPhaseBadge(barcode.phase).text,
                    'Status': getStatusBadge(barcode.barcodeStatus).text,
                    'Brand': barcode.brand || '',                    // 🆕 NEW: Add brand
                    'Category': barcode.category || '',
                    'Location': barcode.location || '',
                    'Assigned To': barcode.assignedTo || '',
                    'Description': barcode.description || '',
                    'Notes': barcode.notes || '',
                    'Created Date': barcode.createdAt ? new Date(barcode.createdAt).toLocaleDateString('fr-FR') : '',
                    'Last Updated': barcode.updatedAt ? new Date(barcode.updatedAt).toLocaleDateString('fr-FR') : ''
                }));

                // Create and download Excel file
                await exportToExcel(exportData, barcodesToExport.length);

            } else {
                throw new Error('No data to export');
            }
        } catch (error) {
            console.error('Export failed:', error);
            showNotification('Export failed: ' + error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

// Add this helper function for Excel export
    const exportToExcel = async (data, totalCount) => {
        try {
            // Create workbook and worksheet
            const ws = {};
            const headers = Object.keys(data[0] || {});

            // Add headers
            headers.forEach((header, index) => {
                const cellRef = String.fromCharCode(65 + index) + '1';
                ws[cellRef] = { v: header, t: 's' };
            });

            // Add data rows
            data.forEach((row, rowIndex) => {
                headers.forEach((header, colIndex) => {
                    const cellRef = String.fromCharCode(65 + colIndex) + (rowIndex + 2);
                    const value = row[header];
                    ws[cellRef] = { v: value, t: typeof value === 'number' ? 'n' : 's' };
                });
            });

            // Set worksheet range
            const range = `A1:${String.fromCharCode(65 + headers.length - 1)}${data.length + 1}`;
            ws['!ref'] = range;

            // Create workbook
            const wb = {
                Sheets: { 'Barcodes': ws },
                SheetNames: ['Barcodes']
            };

            // Generate Excel file
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            // Create and download file
            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            // Generate filename with current date and filter info
            const today = new Date().toISOString().split('T')[0];
            const phaseText = selectedPhase === 'all' ? 'All-Phases' : selectedPhase;
            const filename = `Barcodes_${phaseText}_${today}.xlsx`;

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            // Show success notification
            const filterText = selectedPhase === 'all' ? 'all barcodes' :
                phaseStats.find(p => p.id === selectedPhase)?.name || selectedPhase;
            showNotification(`Successfully exported ${totalCount} barcodes (${filterText}) to Excel!`, 'success');

        } catch (error) {
            console.error('Excel generation failed:', error);
            throw new Error('Failed to generate Excel file');
        }
    };
    const copyBarcodeToClipboard = (barcode) => {
        navigator.clipboard.writeText(barcode).then(() => {
            showNotification('Barcode copied to clipboard!', 'info', 2000); // ← Changement ici
        });
    };



const menuItems = [
    { 
        id: 'barcoding', 
        label: 'Barcoding Database', 
        icon: FileText, // Keep as Lucide icon
        path: '/barcoding' 
    },
    { 
        id: 'mep-solutions', 
        label: 'MEP Solutions', 
        icon: MepIcon, // 🔄 Replace with image
        isImage: true,
        path: '/mep_solutions' 
    },
    { 
        id: 'architectural-solutions', 
        label: 'Architectural Solutions', 
        icon: architecturalIcon , // 🔄 Replace with image
        isImage: true,
        path: '/architectural_solutions' 
    },
    { 
        id: 'civil-solutions', 
        label: 'Civil Solutions', 
        icon: civilIcon, // 🔄 Replace with image
        isImage: true,
        path: '/civil_solutions' 
    },
    { 
        id: 'construction-chemicals', 
        label: 'Construction Chemicals', 
        icon: constructionIcon, // 🔄 Replace with image
        isImage: true,
        path: '/construction_chemicals' 
    },
    { 
        id: 'power-tools', 
        label: 'Power & Industrial Tools', 
        icon: powerToolsIcon, // 🔄 Replace with image
        isImage: true,
        path: '/power_tools' 
    },
    { 
        id: 'sustainable-solutions', 
        label: 'Sustainable Solutions', 
        icon: sustainableIcon, // 🔄 Replace with image
        isImage: true,
        path: '/sustainable_solutions' 
    },
    { 
        id: 'hygienic-solutions', 
        label: 'Hygienic Solutions', 
        icon: hygienicIcon, // 🔄 Replace with image
        isImage: true,
        path: '/hygienic_solutions' 
    },
    { 
        id: 'conversions', 
        label: 'Engineering Conversions', 
        icon: Calculator, // Keep as Lucide icon
        path: '/conversion' 
    },
    { 
        id: 'analytics', 
        label: 'Amazon Products', 
        icon: BarChart3, // Keep as Lucide icon
        path: '/amazon_products' 
    },
    { 
        id: 'team', 
        label: 'Team Management', 
        icon: Users, // Keep as Lucide icon
        path: '/team_management' 
    },
    { 
        id: 'user-management', 
        label: 'User Management', 
        icon: UserCog, // Keep as Lucide icon
        path: '/users_management' 
    },
];

const filteredMenuItems = (menuItems || []).filter(item => {
    // Add safety checks for user
    if (!user) return true; // Show all items if user is not loaded yet
    
    if (item.id === 'team' && user.role === 'user') return false;
    if (item.id === 'settings' && user.role !== 'admin') return false;
    return true;
});

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const getStatusBadge = (status) => {
        // Normaliser le status (minuscules et trim)
        const normalizedStatus = status ? status.toString().toLowerCase().trim() : '';
        
        const statusMap = {
            'available': { text: 'Disponible', class: 'status-available' },
            'busy': { text: 'Occupé', class: 'status-low-stock' },
            'disponible': { text: 'Disponible', class: 'status-available' },
            'occupe': { text: 'Occupé', class: 'status-low-stock' },
            'occupé': { text: 'Occupé', class: 'status-low-stock' }
        };
        
        return statusMap[normalizedStatus] || { text: 'Disponible', class: 'status-available' }; // Par défaut : Disponible
    };
    
    const getPhaseBadge = (phase) => {
        const phaseMap = {
            'initial': { text: 'Phase Initiale', class: 'phase-initial', color: '#059669' },
            'phase2': { text: 'Phase 2', class: 'phase-2', color: '#dc2626' }
        };
        return phaseMap[phase] || { text: 'Inconnu', class: 'phase-unknown', color: '#6b7280' };
    };

    const getPhaseIcon = (phaseId) => {
        const iconMap = {
            'all': Database,
            'initial': CheckCircle,
            'phase2': Clock
        };
        return iconMap[phaseId] || Database;
    };

    // View barcode modal
    const openViewModal = (barcode) => {
        setSelectedBarcode(barcode);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedBarcode(null);
    };

    // Edit barcode modal
    const openEditModal = (barcode) => {
        setSelectedBarcode(barcode);
        setFormData({
            product: barcode.product || '',
            codeEAN13: barcode.codeEAN13 || '',
            barcodeStatus: barcode.barcodeStatus || 'Available',
            productName: barcode.productName || '',
            phase: barcode.phase || 'initial',
            brand: barcode.brand || '',
            category: barcode.category || '',
            location: barcode.location || '',
            assignedTo: barcode.assignedTo || '',
            notes: barcode.notes || '',
            description: barcode.description || ''
        });
        setFormError('');
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedBarcode(null);
        setFormError('');
    };

    const handleEditBarcode = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.codeEAN13 || !formData.productName || !formData.product) {
                throw new Error('Kindly fill all the needed fields (Product, EAN13 Code, Product Name)');
            }

            if (!/^\d{13}$/.test(formData.codeEAN13)) {
                throw new Error('The EAN13 code must contain exactly 13 digits');
            }

            if (formData.phase === 'phase2' && !formData.category) {
                throw new Error('The category is required for Phase 2');
            }

            if (formData.phase === 'initial' && !formData.brand) {
                throw new Error('The brand is required for Initial Phase');
            }

            const cleanFormData = { ...formData };

            if (cleanFormData.phase === 'phase2') {
                delete cleanFormData.brand; // Don't send brand for phase2
            } else if (cleanFormData.phase === 'initial') {
                delete cleanFormData.category; // Don't send category for initial
            }

            const response = await ApiService.updateBarcode(selectedBarcode._id, cleanFormData);

            if (response.success) {
                showNotification('Barcode updated successfully!', 'success');
                closeEditModal();
                loadBarcodes();
                loadPhaseStats();
            }
        } catch (error) {
            setFormError(error.message || 'Error updating barcode');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!user) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Chargement...</p>
            </div>
        );
    }

    const NotificationItem = ({ notification, onRemove }) => {
        const getNotificationStyle = (type) => {
            const baseStyle = {
                padding: '16px 20px',
                borderRadius: '12px',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
                border: '1px solid',
                minWidth: '350px',
                maxWidth: '500px',
                position: 'relative',
                animation: 'slideInRight 0.3s ease-out',
                cursor: 'pointer'
            };

            const styles = {
                success: { ...baseStyle, backgroundColor: '#f0fdf4', borderColor: '#bbf7d0', color: '#166534' },
                error: { ...baseStyle, backgroundColor: '#fef2f2', borderColor: '#fecaca', color: '#dc2626' },
                warning: { ...baseStyle, backgroundColor: '#fffbeb', borderColor: '#fed7aa', color: '#d97706' },
                info: { ...baseStyle, backgroundColor: '#eff6ff', borderColor: '#bfdbfe', color: '#1d4ed8' }
            };

            return styles[type] || styles.info;
        };

        const getIcon = (type) => {
            const iconStyle = { width: '20px', height: '20px' };
            switch (type) {
                case 'success': return <CheckCircle style={iconStyle} />;
                case 'error': return <AlertCircle style={iconStyle} />;
                case 'warning': return <AlertCircle style={iconStyle} />;
                default: return <Bell style={iconStyle} />;
            }
        };
    return (
        <div 
            style={getNotificationStyle(notification.type)}
            onClick={() => onRemove(notification.id)}
        >
            {getIcon(notification.type)}
            <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                    {notification.message}
                </p>
            </div>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove(notification.id);
                }}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    borderRadius: '4px',
                    opacity: 0.7
                }}
            >
                <X style={{ width: '16px', height: '16px' }} />
            </button>
        </div>
    );
};

    return (
        <div className="dashboard-container">
            {/* ADD BARCODE MODAL */}
            {showAddModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#1e40af',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <QrCode style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Ajouter un Code-barres
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Créez une nouvelle entrée dans la base de données
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeAddModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error Message */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* Form */}
                        <form onSubmit={handleAddBarcode}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Row 1: Product and Product Name */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Package style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product *
                                        </label>
                                        <input
                                            type="text"
                                            name="product"
                                            value={formData.product}
                                            onChange={handleInputChange}
                                            placeholder="Ex: BET-001"
                                            required
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Package style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product Name *
                                        </label>
                                        <input
                                            type="text"
                                            name="productName"
                                            value={formData.productName}
                                            onChange={handleInputChange}
                                            placeholder="Ex: Béton C25/30"
                                            required
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 2: Code EAN13 and Barcode Status */}
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <QrCode style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            EAN13 Code *
                                        </label>
                                        <input
                                            type="text"
                                            name="codeEAN13"
                                            value={formData.codeEAN13}
                                            onChange={handleInputChange}
                                            placeholder="1234567890123"
                                            pattern="[0-9]{13}"
                                            maxLength="13"
                                            required
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box',
                                                fontFamily: 'monospace'
                                            }}
                                        />
                                        <small style={{ fontSize: '12px', color: '#6b7280' }}>
                                            Exactly 13 digits
                                        </small>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <CheckCircle style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Statut
                                        </label>
                                            <select
                                                name="barcodeStatus"
                                                value={formData.barcodeStatus}
                                                onChange={handleInputChange}
                                                style={{
                                                    width: '100%',
                                                    padding: '12px',
                                                    border: '1px solid #d1d5db',
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                    boxSizing: 'border-box'
                                                }}
                                            >
                                                <option value="Available">Available</option>
                                                <option value="Busy">Busy</option>
                                            </select>
                                    </div>
                                </div>


                                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Clock style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Phase
                                        </label>
                                        <select
                                            name="phase"
                                            value={formData.phase}
                                            onChange={handleInputChange}
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                            }}
                                        >
                                            <option value="initial">Phase Initiale</option>
                                            <option value="phase2">Phase 2</option>
                                        </select>
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Star style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Brand {formData.phase === 'initial' && <span style={{ color: '#dc2626' }}>*</span>}
                                        </label>
                                        <select
                                            name="brand"
                                            value={formData.brand}
                                            onChange={handleInputChange}
                                            required={formData.phase === 'initial'}
                                            disabled={formData.phase === 'phase2'}
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box',
                                                backgroundColor: formData.phase === 'phase2' ? '#f9fafb' : 'white',
                                                cursor: formData.phase === 'phase2' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <option value="">
                                                {formData.phase === 'phase2' ? 'Not applicable' : 'Select a brand'}
                                            </option>
                                            <option value="xakt">XAKT</option>
                                            <option value="dynamik">Dynamik</option>
                                            <option value="ferox">Ferox</option>
                                        </select>
                                        {formData.phase === 'phase2' && (
                                            <small style={{ fontSize: '12px', color: '#6b7280' }}>
                                                Brand not required for Phase 2
                                            </small>
                                        )}
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Category {formData.phase === 'phase2' && <span style={{ color: '#dc2626' }}>*</span>}
                                        </label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleInputChange}
                                            required={formData.phase === 'phase2'}
                                            disabled={formData.phase === 'initial'}
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box',
                                                backgroundColor: formData.phase === 'initial' ? '#f9fafb' : 'white',
                                                cursor: formData.phase === 'initial' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <option value="">
                                                {formData.phase === 'initial' ? 'Not applicable' : 'Select a category'}
                                            </option>
                                            <option value="cable_trays_accessories">Cable Trays & Accessories</option>
                                            <option value="frp_cable_tray">FiberGlass Reinforced Plastic FRP Cable Tray/Ladder</option>
                                            <option value="cable_ladders">Cable Ladders (Welded & Swaged)</option>
                                            <option value="cable_trunkings">Cable Trunkings</option>
                                            <option value="underfloor_trunkings">Underfloor Trunkings</option>
                                            <option value="weatherproof_cable_trunk">Weatherproof Cable Trunk</option>
                                            <option value="cable_management_support">Cable Management Support Systems</option>
                                            <option value="basket_trays_accessories">Basket Trays & Accessories</option>
                                            <option value="stair_nosing">Stair Nosing</option>
                                            <option value="tape">Tape</option>
                                            <option value="skirting">Skirting</option>
                                            <option value="movement_joints">Movement Joints</option>
                                            <option value="channel_strips">Channel Strips</option>
                                            <option value="landscaping">Landscaping</option>
                                            <option value="tactile">Tactile</option>
                                            <option value="rubber_gasket">Rubber Gasket</option>
                                            <option value="entrance_matting_system">Entrance Matting System</option>
                                            <option value="expansion_joints">Expansion Joints</option>
                                            <option value="fire_barrier">Fire Barrier</option>
                                            <option value="ferox_access_panels">Ferox Access Panels</option>
                                            <option value="ferox_steel_doors">Ferox Steel Doors</option>
                                            <option value="pipe_clamps_hangers">Pipe Clamps & Hangers</option>
                                            <option value="threaded_accessoris_pipe_clamps">Threaded Accessories & Pipe Clamps</option>
                                            <option value="c_channel_runs">C-Channel Runs</option>
                                            <option value="toothed_channels">Toothed Channels</option>
                                            <option value="c_channel_fittings">C-Channel Fittings</option>
                                            <option value="c_channel_accessories">C-Channel Accessories</option>
                                            <option value="c_channel_anchors">C-Channel Anchors</option>
                                            <option value="cable_fastenning_system">Cable Fastening System</option>
                                            <option value="galvanized_threaded_rods">Galvanized Threaded Rods</option>
                                            <option value="metal_ceiling_grid_system">Metal Ceiling Grid System</option>
                                            <option value="gfrp">Glass Fiber Reinforced Plastic (GFRP)</option>
                                            <option value="phenolic_partition_systems">Phenolic Partition Systems</option>
                                            <option value="paints">Paints</option>

                                        </select>
                                        {formData.phase === 'initial' && (
                                            <small style={{ fontSize: '12px', color: '#6b7280' }}>
                                                Category not required for Initial Phase
                                            </small>
                                        )}
                                    </div>
                                </div>
                                {/* Row 3: Location and Assigned To */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Globe style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Location
                                        </label>
                                        <input
                                            type="text"
                                            name="location"
                                            value={formData.location}
                                            onChange={handleInputChange}
                                            placeholder="Ex: Warehouse A - Section 1"
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <User style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Assigned To
                                        </label>
                                        <input
                                            type="text"
                                            name="assignedTo"
                                            value={formData.assignedTo}
                                            onChange={handleInputChange}
                                            placeholder="Ex: Jean Dupont"
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 4: Description */}
                                <div>
                                    <label style={{
                                        display: 'block', fontSize: '14px', fontWeight: '500',
                                        color: '#374151', marginBottom: '6px'
                                    }}>
                                        Description
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="Product description..."
                                        rows="2"
                                        style={{
                                            width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                            borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical'
                                        }}
                                    />
                                </div>

                                {/* Row 5: Notes */}
                                <div>
                                    <label style={{
                                        display: 'block', fontSize: '14px', fontWeight: '500',
                                        color: '#374151', marginBottom: '6px'
                                    }}>
                                        Notes
                                    </label>
                                    <textarea
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleInputChange}
                                        placeholder="Additional notes..."
                                        rows="2"
                                        style={{
                                            width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                            borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div style={{
                                display: 'flex', gap: '12px', marginTop: '24px',
                                paddingTop: '20px', borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    type="button"
                                    onClick={closeAddModal}
                                    style={{
                                        flex: 1, padding: '12px 20px', border: '1px solid #d1d5db',
                                        background: 'white', color: '#374151', borderRadius: '8px',
                                        fontSize: '14px', fontWeight: '500', cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        flex: 2, padding: '12px 20px', border: 'none',
                                        background: isSubmitting ? '#9ca3af' : '#1e40af',
                                        color: 'white', borderRadius: '8px', fontSize: '14px',
                                        fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Creating...
                                        </>
                                    ) : (
                                        <>
                                            <QrCode style={{ width: '16px', height: '16px' }} />
                                            Create Barcode
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showViewModal && selectedBarcode && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '500px', maxHeight: '90vh', overflow: 'auto'
                    }}>
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#059669',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                        Barcode Details
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedBarcode.codeEAN13}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>

                        {/* Details */}
                        <div style={{ display: 'grid', gap: '16px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CODE EAN13</label>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', fontFamily: 'monospace' }}>{selectedBarcode.codeEAN13}</p>
                                        <button
                                            onClick={() => copyBarcodeToClipboard(selectedBarcode.codeEAN13)}
                                            style={{ padding: '4px', border: 'none', background: 'none', cursor: 'pointer' }}
                                            title="Copier"
                                        >
                                            <Copy style={{ width: '14px', height: '14px', color: '#6b7280' }} />
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PRODUCT</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedBarcode.product}</p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PRODUIT</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedBarcode.productName}</p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PHASE</label>
                                    <span style={{
                                        display: 'inline-block',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        backgroundColor: getPhaseBadge(selectedBarcode.phase).color + '20',
                                        color: getPhaseBadge(selectedBarcode.phase).color
                                    }}>
                            {getPhaseBadge(selectedBarcode.phase).text}
                        </span>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>STATUT</label>
                                    <span style={{
                                        display: 'inline-block',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        backgroundColor: getStatusBadge(selectedBarcode.barcodeStatus).class === 'status-available' ? '#059669' + '20' : '#dc2626' + '20',
                                        color: getStatusBadge(selectedBarcode.barcodeStatus).class === 'status-available' ? '#059669' : '#dc2626'
                                    }}>
                            {getStatusBadge(selectedBarcode.barcodeStatus).text}
                        </span>
                                </div>

                                {/* 🆕 NEW: Brand field - only show for initial phase */}
                                {selectedBarcode.phase === 'initial' && (
                                    <div>
                                        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>BRAND</label>
                                        {selectedBarcode.brand && selectedBarcode.brand.trim() !== '' ? (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <Star style={{ width: '14px', height: '14px', color: '#f59e0b' }} />
                                                <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', textTransform: 'capitalize' }}>
                                                    {selectedBarcode.brand}
                                                </p>
                                            </div>
                                        ) : (
                                            <p style={{ margin: 0, fontSize: '14px', color: '#dc2626', fontStyle: 'italic' }}>
                                                Brand required
                                            </p>
                                        )}
                                    </div>
                                )}

                                {selectedBarcode.phase === 'phase2' && (
                                    <div>
                                        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CATEGORY</label>
                                        {selectedBarcode.category && selectedBarcode.category.trim() !== '' ? (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <Layers style={{ width: '14px', height: '14px', color: '#6b7280' }} />
                                                <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', textTransform: 'capitalize' }}>
                                                    {selectedBarcode.category}
                                                </p>
                                            </div>
                                        ) : (
                                            <p style={{ margin: 0, fontSize: '14px', color: '#dc2626', fontStyle: 'italic' }}>
                                                Category required
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>

                            {selectedBarcode.location && (
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>LOCALISATION</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedBarcode.location}</p>
                                </div>
                            )}

                            {selectedBarcode.assignedTo && (
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>ASSIGNÉ À</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedBarcode.assignedTo}</p>
                                </div>
                            )}

                            {selectedBarcode.description && (
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
                                    <p style={{ margin: 0, fontSize: '14px' }}>{selectedBarcode.description}</p>
                                </div>
                            )}

                            {selectedBarcode.notes && (
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>NOTES</label>
                                    <p style={{ margin: 0, fontSize: '14px' }}>{selectedBarcode.notes}</p>
                                </div>
                            )}

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CRÉÉ LE</label>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {new Date(selectedBarcode.createdAt).toLocaleDateString('fr-FR')}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>MODIFIÉ LE</label>
                                    <p style={{ margin: 0, fontSize: '14px' }}>
                                        {new Date(selectedBarcode.updatedAt).toLocaleDateString('fr-FR')}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <button onClick={closeViewModal} style={{
                            width: '100%', padding: '12px', marginTop: '20px',
                            border: '1px solid #d1d5db', background: 'white',
                            borderRadius: '8px', cursor: 'pointer'
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* EDIT BARCODE MODAL */}
            {showEditModal && selectedBarcode && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#f59e0b',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Edit Barcode
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedBarcode.barcode}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeEditModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        <form onSubmit={handleEditBarcode}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Same form fields as add modal but for editing */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <QrCode style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Code-barres *
                                        </label>
                                                <input
                                                    type="text"
                                                    name="codeEAN13"
                                                    value={formData.codeEAN13}
                                                    onChange={handleInputChange}
                                                    pattern="[0-9]{13}"
                                                    maxLength="13"
                                                    required
                                                    style={{
                                                        width: '100%', 
                                                        padding: '12px', 
                                                        border: '1px solid #d1d5db', 
                                                        borderRadius: '8px', 
                                                        fontSize: '14px', 
                                                        boxSizing: 'border-box',
                                                        fontFamily: 'monospace'
                                                    }}
                                                />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Package style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product Name *
                                        </label>
                                        <input
                                            type="text"
                                            name="productName"
                                            value={formData.productName}
                                            onChange={handleInputChange}
                                            required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Phase
                                        </label>
                                        <select
                                            name="phase"
                                            value={formData.phase}
                                            onChange={handleInputChange}
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        >
                                            <option value="initial">Phase Initiale</option>
                                            <option value="phase2">Phase 2</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Statut
                                        </label>
                                        <select
                                            name="barcodeStatus"
                                            value={formData.barcodeStatus}
                                            onChange={handleInputChange}
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            <option value="Available">Available</option>
                                            <option value="Busy">Busy</option>
                                        </select>
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Star style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Brand {formData.phase === 'initial' && <span style={{ color: '#dc2626' }}>*</span>}
                                        </label>
                                        <select
                                            name="brand"
                                            value={formData.brand}
                                            onChange={handleInputChange}
                                            required={formData.phase === 'initial'}
                                            disabled={formData.phase === 'phase2'}
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box',
                                                backgroundColor: formData.phase === 'phase2' ? '#f9fafb' : 'white',
                                                cursor: formData.phase === 'phase2' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <option value="">
                                                {formData.phase === 'phase2' ? 'Not applicable' : 'Select a brand'}
                                            </option>
                                            <option value="xakt">XAKT</option>
                                            <option value="dynamik">Dynamik</option>
                                            <option value="ferox">Ferox</option>
                                        </select>
                                        {formData.phase === 'phase2' && (
                                            <small style={{ fontSize: '12px', color: '#6b7280' }}>
                                                Brand not required for Phase 2
                                            </small>
                                        )}
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block', fontSize: '14px', fontWeight: '500',
                                            color: '#374151', marginBottom: '6px'
                                        }}>
                                            <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Category {formData.phase === 'phase2' && <span style={{ color: '#dc2626' }}>*</span>}
                                        </label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleInputChange}
                                            required={formData.phase === 'phase2'}
                                            disabled={formData.phase === 'initial'}
                                            style={{
                                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box',
                                                backgroundColor: formData.phase === 'initial' ? '#f9fafb' : 'white',
                                                cursor: formData.phase === 'initial' ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <option value="">
                                                {formData.phase === 'initial' ? 'Not applicable' : 'Select a category'}
                                            </option>
                                            <option value="cable_trays_accessories">Cable Trays & Accessories</option>
                                            <option value="frp_cable_tray">FiberGlass Reinforced Plastic FRP Cable Tray/Ladder</option>
                                            <option value="cable_ladders">Cable Ladders (Welded & Swaged)</option>
                                            <option value="cable_trunkings">Cable Trunkings</option>
                                            <option value="underfloor_trunkings">Underfloor Trunkings</option>
                                            <option value="weatherproof_cable_trunk">Weatherproof Cable Trunk</option>
                                            <option value="cable_management_support">Cable Management Support Systems</option>
                                            <option value="basket_trays_accessories">Basket Trays & Accessories</option>
                                            <option value="stair_nosing">Stair Nosing</option>
                                            <option value="tape">Tape</option>
                                            <option value="skirting">Skirting</option>
                                            <option value="movement_joints">Movement Joints</option>
                                            <option value="channel_strips">Channel Strips</option>
                                            <option value="landscaping">Landscaping</option>
                                            <option value="tactile">Tactile</option>
                                            <option value="rubber_gasket">Rubber Gasket</option>
                                            <option value="entrance_matting_system">Entrance Matting System</option>
                                            <option value="expansion_joints">Expansion Joints</option>
                                            <option value="fire_barrier">Fire Barrier</option>
                                            <option value="ferox_access_panels">Ferox Access Panels</option>
                                            <option value="ferox_steel_doors">Ferox Steel Doors</option>
                                            <option value="pipe_clamps_hangers">Pipe Clamps & Hangers</option>
                                            <option value="threaded_accessoris_pipe_clamps">Threaded Accessories & Pipe Clamps</option>
                                            <option value="c_channel_runs">C-Channel Runs</option>
                                            <option value="toothed_channels">Toothed Channels</option>
                                            <option value="c_channel_fittings">C-Channel Fittings</option>
                                            <option value="c_channel_accessories">C-Channel Accessories</option>
                                            <option value="c_channel_anchors">C-Channel Anchors</option>
                                            <option value="cable_fastenning_system">Cable Fastening System</option>
                                            <option value="galvanized_threaded_rods">Galvanized Threaded Rods</option>
                                            <option value="metal_ceiling_grid_system">Metal Ceiling Grid System</option>
                                            <option value="gfrp">Glass Fiber Reinforced Plastic (GFRP)</option>
                                            <option value="phenolic_partition_systems">Phenolic Partition Systems</option>
                                            <option value="paints">Paints</option>

                                        </select>
                                        {formData.phase === 'initial' && (
                                            <small style={{ fontSize: '12px', color: '#6b7280' }}>
                                                Category not required for Initial Phase
                                            </small>
                                        )}
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Location
                                        </label>
                                        <input
                                            type="text"
                                            name="location"
                                            value={formData.location}
                                            onChange={handleInputChange}
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Assigned To
                                        </label>
                                        <input
                                            type="text"
                                            name="assignedTo"
                                            value={formData.assignedTo}
                                            onChange={handleInputChange}
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Description
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        rows="2"
                                        style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Notes
                                    </label>
                                    <textarea
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleInputChange}
                                        rows="2"
                                        style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button
                                    type="button"
                                    onClick={closeEditModal}
                                    style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        flex: 2, padding: '12px 20px', border: 'none',
                                        background: isSubmitting ? '#9ca3af' : '#f59e0b',
                                        color: 'white', borderRadius: '8px', fontSize: '14px',
                                        fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <Edit style={{ width: '16px', height: '16px' }} />
                                            Update
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}


            {/* STATS MODAL - Add this after your other modals */}
            {showStatsModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '800px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#2563eb',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <BarChart3 style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Barcode Statistics
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Detailed analytics and insights
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeStatsModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Loading State */}
                        {statsLoading && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{
                                    width: '24px',
                                    height: '24px',
                                    margin: '0 auto 16px',
                                    animation: 'spin 1s linear infinite'
                                }} />
                                <p>Loading statistics...</p>
                            </div>
                        )}

                        {/* Stats Content */}
                        {!statsLoading && detailedStats && (
                            <div style={{ display: 'grid', gap: '24px' }}>
                                {/* Overview Cards */}
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                                    <div style={{
                                        padding: '20px', backgroundColor: '#f0f9ff', borderRadius: '8px',
                                        border: '1px solid #0ea5e9'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                            <Database style={{ width: '16px', height: '16px', color: '#0ea5e9' }} />
                                            <span style={{ fontSize: '12px', fontWeight: '500', color: '#0ea5e9' }}>TOTAL</span>
                                        </div>
                                        <div style={{ fontSize: '24px', fontWeight: '700', color: '#0c4a6e' }}>
    {detailedStats.totalBarcodes?.toLocaleString() || '0'}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>Barcodes</div>
                                    </div>

                                    <div style={{
                                        padding: '20px', backgroundColor: '#f0fdf4', borderRadius: '8px',
                                        border: '1px solid #059669'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                            <CheckCircle style={{ width: '16px', height: '16px', color: '#059669' }} />
                                            <span style={{ fontSize: '12px', fontWeight: '500', color: '#059669' }}>AVAILABLE</span>
                                        </div>
                                        <div style={{ fontSize: '24px', fontWeight: '700', color: '#065f46' }}>
{detailedStats.totalAvailable?.toLocaleString() || '0'}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                            {detailedStats.availablePercentage}% of total
                                        </div>
                                    </div>

                                    <div style={{
                                        padding: '20px', backgroundColor: '#fef2f2', borderRadius: '8px',
                                        border: '1px solid #dc2626'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                            <Clock style={{ width: '16px', height: '16px', color: '#dc2626' }} />
                                            <span style={{ fontSize: '12px', fontWeight: '500', color: '#dc2626' }}>BUSY</span>
                                        </div>
                                        <div style={{ fontSize: '24px', fontWeight: '700', color: '#991b1b' }}>
{detailedStats.totalBusy?.toLocaleString() || '0'}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                            {detailedStats.busyPercentage}% of total
                                        </div>
                                    </div>

                                    <div style={{
                                        padding: '20px', backgroundColor: '#fefce8', borderRadius: '8px',
                                        border: '1px solid #eab308'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                            <Activity style={{ width: '16px', height: '16px', color: '#eab308' }} />
                                            <span style={{ fontSize: '12px', fontWeight: '500', color: '#eab308' }}>UTILIZATION</span>
                                        </div>
                                        <div style={{ fontSize: '24px', fontWeight: '700', color: '#92400e' }}>
                                            {detailedStats.utilizationRate}%
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#6b7280' }}>Overall usage</div>
                                    </div>
                                </div>



                                {/* Recent Activity */}
                                {detailedStats.recentActivity && detailedStats.recentActivity.length > 0 && (
                                    <div style={{
                                        padding: '20px', backgroundColor: 'white', borderRadius: '8px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <h3 style={{
                                            margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600',
                                            display: 'flex', alignItems: 'center', gap: '8px'
                                        }}>
                                            <Activity style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                            Recent Activity
                                        </h3>
                                        <div style={{ display: 'grid', gap: '8px' }}>
                                            {detailedStats.recentActivity.slice(0, 5).map((activity, index) => (
                                                <div key={index} style={{
                                                    padding: '12px', backgroundColor: '#f8fafc', borderRadius: '6px',
                                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                                }}>
                                                    <div>
                                            <span style={{ fontWeight: '500', fontSize: '14px' }}>
                                                {activity.productName || activity.product}
                                            </span>
                                                        <span style={{ color: '#6b7280', fontSize: '12px', marginLeft: '8px' }}>
                                                {activity.action}
                                            </span>
                                                    </div>
                                                    <span style={{ fontSize: '12px', color: '#6b7280' }}>
                                            {new Date(activity.date).toLocaleDateString('fr-FR')}
                                        </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Error State */}
                        {!statsLoading && !detailedStats && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b'
                            }}>
                                <AlertCircle style={{
                                    width: '24px',
                                    height: '24px',
                                    margin: '0 auto 16px',
                                    color: '#dc2626'
                                }} />
                                <p>Failed to load statistics</p>
                                <button
                                    onClick={loadDetailedStats}
                                    style={{
                                        marginTop: '12px',
                                        padding: '8px 16px',
                                        backgroundColor: '#1e40af',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Retry
                                </button>
                            </div>
                        )}

                        {/* Close Button */}
                        <div style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                            <button onClick={closeStatsModal} style={{
                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                background: 'white', borderRadius: '8px', cursor: 'pointer',
                                fontSize: '14px', fontWeight: '500'
                            }}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Sidebar */}
            <aside className="sidebar">
                    <div className="sidebar-header">
                        <div 
                            className="sidebar-logo-container"
                            onClick={() => navigate('/dashboard')}
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                borderRadius: '8px',
                                padding: '8px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                e.currentTarget.style.transform = 'scale(1.02)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                            title="Retour au Dashboard"
                        >
                            <div className="sidebar-logo">
                                <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                            </div>
                            <div className="sidebar-brand">
                                <h1 className="sidebar-title">UNITECH IKK</h1>
                                <p className="sidebar-subtitle">Enterprise Dashboard</p>
                            </div>
                        </div>
                    </div>

<nav className="sidebar-nav">
  {filteredMenuItems.map((item) => (
    <div
      key={item.id}
      className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
      onClick={() => {
        setActiveMenuItem(item.id);
        navigate(item.path);
      }}
    >
      {item.isImage ? (
        <img 
          src={item.icon} 
          alt={item.label}
          className="nav-icon-image"
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures proper alignment
          }}
        />
      ) : (
        <item.icon 
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures consistency with images
          }} 
        />
      )}
      <span className="nav-text">{item.label}</span>
    </div>
  ))}
</nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <QrCode style={{ width: '16px', height: '16px' }} />
                                    <span>Barcoding</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Database</span>
                                </div>
                            </nav>
                        </div>

                    <div className="header-right">
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Rechercher..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                        </div>

                        <div className="header-actions">
                            <button
                                className="header-button"
                                onClick={handleRefresh}
                                disabled={isLoading}
                                title="Actualiser"
                            >
                                <RefreshCw style={{
                                    width: '18px',
                                    height: '18px',
                                    transform: isLoading ? 'rotate(360deg)' : 'none',
                                    transition: 'transform 1s linear'
                                }} />
                            </button>

                            <button 
                                className="header-button"
                                title="Notifications"
                            >
                                <Bell style={{ width: '18px', height: '18px' }} />
                                {notifications.length > 0 && (
                                    <span className="notification-badge">{notifications.length}</span>
                                )}
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/settings')}
                                title="Paramètres système"
                            >
                                <Settings style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/project_management')}
                                title="Gestion de projets"
                            >
                                <Folder style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/technical_support')}
                                title="Technical Support"
                            >
                                <MonitorCog style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/admin_support_it')}
                                title="Admin Support IT"
                            >
                                <SquareActivity style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/mytickets')}
                                title="My Tickets"
                            >
                                <Tickets style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/quotations')}
                                title="Quotation System"
                            >
                                <Receipt style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/clients')}
                                title="Clients"
                            >
                                <Briefcase style={{ width: '18px', height: '18px' }} />
                            </button>

                            <div className="time-display">
                                {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    </div>
                    </div>
                </header>

                {/* Barcoding Content */}
                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Barcodes Database</h1>
                        <p className="page-subtitle">
                            Manage and track all your barcodes by project phase.
                        </p>

                        <div className="page-actions">
                            <button 
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <QrCode style={{ width: '16px', height: '16px' }} />
                                Ajouter Code-barres
                            </button>
                            <button className="action-button secondary">
                                <Scan style={{ width: '16px', height: '16px' }} />
                                Scanner
                            </button>
                            <button
                                className="action-button secondary"
                                onClick={handleExportBarcodes}
                                disabled={isLoading}
                                title={selectedPhase === 'all' ? 'Export all barcodes' : `Export ${phaseStats.find(p => p.id === selectedPhase)?.name || selectedPhase} barcodes`}
                            >
                                {isLoading ? (
                                    <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                ) : (
                                    <Download style={{ width: '16px', height: '16px' }} />
                                )}
                                Exporter {selectedPhase !== 'all' && `(${phaseStats.find(p => p.id === selectedPhase)?.name || selectedPhase})`}
                            </button>
                            <button className="action-button secondary">
                                <BarChart2 style={{ width: '16px', height: '16px' }} />
                                Rapport
                            </button>

                            <button
                                className="action-button secondary"
                                onClick={openStatsModal}
                                title="View detailed barcode statistics"
                            >
                                <BarChart3 style={{ width: '16px', height: '16px' }} />
                                View Barcode Stats
                            </button>
                        </div>
                    </div>

                    {/* Phase Categories Section */}
                    <div className="categories-section">
                        <h2 className="section-title">Phases du Projet</h2>
                        <div className="categories-grid">
                            {phaseStats.map((phase) => {
                                const IconComponent = getPhaseIcon(phase.id);
                                return (
                                    <div
                                        key={phase.id}
                                        className={`category-card ${selectedPhase === phase.id ? 'active' : ''}`}
                                        onClick={() => setSelectedPhase(phase.id)}
                                        style={{
                                            borderLeft: `4px solid ${phase.color || '#1e40af'}`
                                        }}
                                    >
                                        <div className="category-header">
                                            <div className="category-icon" style={{ backgroundColor: phase.color || '#1e40af' }}>
                                                <IconComponent style={{ width: '20px', height: '20px', color: 'white' }} />
                                            </div>
                                            <h3 className="category-name">{phase.name}</h3>
                                        </div>
                                        <p className="category-count">{phase.count} codes-barres</p>
                                        <div style={{ 
                                            width: '100%', 
                                            height: '4px', 
                                            backgroundColor: '#f3f4f6', 
                                            borderRadius: '2px',
                                            marginTop: '8px'
                                        }}>
                                            <div style={{ 
                                                width: phase.id === 'all' ? '100%' : `${Math.min(100, (phase.count / Math.max(1, phaseStats.find(p => p.id === 'all')?.count || 1)) * 100)}%`,
                                                height: '100%', 
                                                backgroundColor: phase.color || '#1e40af',
                                                borderRadius: '2px'
                                            }} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Filters Section */}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">Research</label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Barcodes , Products ..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Sort By</label>
                                <select
                                    className="filter-select"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="createdAt">Creation Date</option>
                                    <option value="barcode">Barcode</option>
                                    <option value="productName">Product Name</option>
                                    <option value="updatedAt">Last Updated</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Order</label>
                                <select
                                    className="filter-select"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="desc">Most Recent</option>
                                    <option value="asc">Oldest</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Actions</label>
                                <button className="action-button secondary">
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres avancés
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Barcodes Table */}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                {selectedPhase === 'all' ? 'All Barcodes' : 
                                 phaseStats.find(p => p.id === selectedPhase)?.name || 'Barcodes'}
                            </h2>
                            <span className="table-stats">
                                {pagination.total} barcode{pagination.total > 1 ? 's' : ''} found
                                {isLoading && ' (loading...)'}
                            </span>
                        </div>

                        <table className="products-table">
                            <thead className="table-head">
                            <tr>
                                <th onClick={() => {
                                    setSortBy('codeEAN13');
                                    setSortOrder(sortBy === 'codeEAN13' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Code-barres {sortBy === 'codeEAN13' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('productName');
                                    setSortOrder(sortBy === 'productName' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Product {sortBy === 'productName' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Phase</th>
                                <th>Status</th>
                                {/* 🆕 NEW: Add Brand/Category column */}
                                <th>Brand/Category</th>
                                <th>Location</th>
                                <th>Assigned To</th>
                                <th onClick={() => {
                                    setSortBy('updatedAt');
                                    setSortOrder(sortBy === 'updatedAt' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Last Updated {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody className="table-body">
                            {barcodes.map((barcode) => {
                                const status = getStatusBadge(barcode.barcodeStatus);
                                const phase = getPhaseBadge(barcode.phase);

                                return (
                                    <tr key={barcode._id}>
                                        {/* COLUMN 1: Code-barres (EAN13) */}
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <QrCode style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                                <div>
                                                    <div className="product-name" style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                                        {barcode.codeEAN13 || 'N/A'}
                                                    </div>
                                                    {barcode.product && barcode.product !== '1' && barcode.product.trim() !== '' && (
                                                        <div className="product-sku" style={{ fontSize: '12px', color: '#6b7280' }}>
                                                            Ref: {barcode.product}
                                                        </div>
                                                    )}
                                                </div>
                                                <button
                                                    onClick={() => copyBarcodeToClipboard(barcode.codeEAN13 || '')}
                                                    style={{
                                                        padding: '4px', border: 'none', background: 'none',
                                                        cursor: 'pointer', borderRadius: '4px'
                                                    }}
                                                    title="Copier le code-barres"
                                                >
                                                    <Copy style={{ width: '14px', height: '14px', color: '#6b7280' }} />
                                                </button>
                                            </div>
                                        </td>

                                        {/* COLUMN 2: Produit (productName) */}
                                        <td>
                                            <div>
                                                <div className="product-name" style={{ fontWeight: '500' }}>
                                                    {barcode.productName && barcode.productName.trim() !== ''
                                                        ? barcode.productName
                                                        : (barcode.product && barcode.product.trim() !== ''
                                                            ? barcode.product
                                                            : 'Nom du produit non défini')}
                                                </div>
                                                {barcode.description && barcode.description.trim() !== '' && (
                                                    <div className="product-sku" style={{ fontSize: '12px', color: '#6b7280' }}>
                                                        {barcode.description.length > 50
                                                            ? barcode.description.substring(0, 50) + '...'
                                                            : barcode.description}
                                                    </div>
                                                )}
                                            </div>
                                        </td>

                                        {/* COLUMN 3: Phase */}
                                        <td>
                                        <span
                                            className={`status-badge ${phase.class}`}
                                            style={{
                                                backgroundColor: phase.color + '20',
                                                color: phase.color,
                                                border: `1px solid ${phase.color}40`,
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {phase.text}
                                        </span>
                                        </td>
                                        <td>
                                    <span 
                                        className={`status-badge ${status.class}`}
                                        style={{ whiteSpace: 'nowrap' }}
                                    >
                                        {status.text}
                                    </span>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                {barcode.phase === 'initial' ? (
                                                    // Show brand for initial phase
                                                    barcode.brand && barcode.brand.trim() !== '' ? (
                                                        <>
                                                            <Star style={{ width: '14px', height: '14px', color: '#f59e0b' }} />
                                                            <span style={{ fontSize: '14px', textTransform: 'capitalize' }}>
                                            {barcode.brand}
                                        </span>
                                                        </>
                                                    ) : (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                            <Star style={{ width: '14px', height: '14px', color: '#dc2626', opacity: 0.5 }} />
                                                            <span style={{
                                                                fontSize: '12px',
                                                                color: '#dc2626',
                                                                fontStyle: 'italic',
                                                                padding: '2px 6px',
                                                                backgroundColor: '#fee2e2',
                                                                borderRadius: '4px'
                                                            }}>
                                            Brand needed
                                        </span>
                                                        </div>
                                                    )
                                                ) : (
                                                    barcode.category && barcode.category.trim() !== '' ? (
                                                        <>
                                                            <Layers style={{ width: '14px', height: '14px', color: '#6b7280' }} />
                                                            <span style={{ fontSize: '14px' }}>
                                                                {getCategoryDisplayName(barcode.category)}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                            <Layers style={{ width: '14px', height: '14px', color: '#dc2626', opacity: 0.5 }} />
                                                            <span style={{
                                                                fontSize: '12px',
                                                                color: '#dc2626',
                                                                fontStyle: 'italic',
                                                                padding: '2px 6px',
                                                                backgroundColor: '#fee2e2',
                                                                borderRadius: '4px'
                                                            }}>
                                            Category needed
                                        </span>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </td>

                                        {/* COLUMN 6: Localisation */}
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                {barcode.location && barcode.location.trim() !== '' ? (
                                                    <>
                                                        <Globe style={{ width: '14px', height: '14px', color: '#6b7280' }} />
                                                        <span style={{ fontSize: '14px' }}>{barcode.location}</span>
                                                    </>
                                                ) : (
                                                    <span style={{ fontSize: '14px', color: '#9ca3af', fontStyle: 'italic' }}>
                                    Non définie
                                </span>
                                                )}
                                            </div>
                                        </td>

                                        {/* COLUMN 7: Assigné à */}
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                {barcode.assignedTo && barcode.assignedTo.trim() !== '' ? (
                                                    <>
                                                        <User style={{ width: '14px', height: '14px', color: '#6b7280' }} />
                                                        <span style={{ fontSize: '14px' }}>{barcode.assignedTo}</span>
                                                    </>
                                                ) : (
                                                    <span style={{ fontSize: '14px', color: '#9ca3af', fontStyle: 'italic' }}>
                                    Non assigné
                                </span>
                                                )}
                                            </div>
                                        </td>

                                        {/* COLUMN 8: Date */}
                                        <td>
                                            {barcode.updatedAt ? new Date(barcode.updatedAt).toLocaleDateString('fr-FR', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit'
                                            }) : 'N/A'}
                                        </td>

                                        {/* COLUMN 9: Actions */}
                                        <td>
                                            <div className="actions-cell">
                                                <button
                                                    className="action-icon"
                                                    title="Voir détails"
                                                    onClick={() => openViewModal(barcode)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Eye style={{ width: '16px', height: '16px' }} />
                                                </button>
                                                <button
                                                    className="action-icon"
                                                    title="Copier code-barres"
                                                    onClick={() => copyBarcodeToClipboard(barcode.codeEAN13 || '')}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Copy style={{ width: '16px', height: '16px' }} />
                                                </button>
                                                {(user.role === 'manager' || user.role === 'admin') && (
                                                    <button
                                                        className="action-icon edit"
                                                        title="Modifier"
                                                        onClick={() => openEditModal(barcode)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Edit style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                                {user.role === 'admin' && (
                                                    <button
                                                        className="action-icon delete"
                                                        title="Supprimer"
                                                        onClick={() => handleDeleteBarcode(barcode._id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Trash2 style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>

                        {barcodes.length === 0 && !isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <QrCode style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    No barcodes found
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    Try modifying your search criteria or filters.
                                </p>
                                <button 
                                    onClick={openAddModal}
                                    style={{
                                        marginTop: '16px',
                                        padding: '8px 16px',
                                        backgroundColor: '#1e40af',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        margin: '16px auto 0'
                                    }}
                                >
                                    <QrCode style={{ width: '16px', height: '16px' }} />
                                    Add first barcode
                                </button>
                            </div>
                        )}

                        {isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{ 
                                    width: '24px', 
                                    height: '24px', 
                                    margin: '0 auto 16px', 
                                    animation: 'spin 1s linear infinite' 
                                }} />
                                <p>Loading barcodes...</p>
                            </div>
                        )}

                        {/* Pagination */}
{pagination.pages > 1 && (
    <div style={{ 
        padding: '20px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        gap: '15px',
        flexWrap: 'wrap',
        borderTop: '1px solid #e5e7eb'
    }}>
        {/* Bouton Précédent */}
        <button 
            onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
            disabled={pagination.page === 1}
            style={{
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                background: pagination.page === 1 ? '#f9fafb' : 'white',
                color: pagination.page === 1 ? '#9ca3af' : '#374151',
                cursor: pagination.page === 1 ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            }}
        >
            <ChevronRight style={{ width: '14px', height: '14px', transform: 'rotate(180deg)' }} />
            Précédent
        </button>

        {/* Navigation par numéros de page */}
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            background: '#f8fafc',
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
        }}>
            {/* Première page */}
            {pagination.page > 3 && (
                <>
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: 1 }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: 'white',
                            color: '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            minWidth: '32px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                    >
                        1
                    </button>
                    {pagination.page > 4 && (
                        <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                    )}
                </>
            )}

            {/* Pages autour de la page actuelle */}
            {Array.from({ length: pagination.pages }, (_, i) => i + 1)
                .filter(page => 
                    page >= Math.max(1, pagination.page - 2) && 
                    page <= Math.min(pagination.pages, pagination.page + 2)
                )
                .map(page => (
                    <button
                        key={page}
                        onClick={() => setPagination(prev => ({ ...prev, page }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: page === pagination.page ? '#1e40af' : 'white',
                            color: page === pagination.page ? 'white' : '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: page === pagination.page ? '600' : '500',
                            minWidth: '32px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            if (page !== pagination.page) {
                                e.target.style.backgroundColor = '#e5e7eb';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (page !== pagination.page) {
                                e.target.style.backgroundColor = 'white';
                            }
                        }}
                    >
                        {page}
                    </button>
                ))
            }

            {/* Dernière page */}
            {pagination.page < pagination.pages - 2 && (
                <>
                    {pagination.page < pagination.pages - 3 && (
                        <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                    )}
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: pagination.pages }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: 'white',
                            color: '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            minWidth: '32px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                    >
                        {pagination.pages}
                    </button>
                </>
            )}
        </div>

        {/* Input direct pour aller à une page */}
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            background: '#f8fafc',
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
        }}>
            <QrCode style={{ width: '16px', height: '16px', color: '#6b7280' }} />
            <span style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                Aller à:
            </span>
            <input
                type="number"
                min="1"
                max={pagination.pages}
                placeholder={pagination.page}
                style={{
                    width: '60px',
                    padding: '4px 8px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '14px',
                    textAlign: 'center',
                    outline: 'none'
                }}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        const page = parseInt(e.target.value);
                        if (page >= 1 && page <= pagination.pages) {
                            setPagination(prev => ({ ...prev, page }));
                            e.target.value = '';
                            // Notification de navigation
                            showNotification(`Navigation vers la page ${page}`, 'info', 2000);
                        } else {
                            showNotification('Numéro de page invalide', 'error', 3000);
                        }
                    }
                }}
                onBlur={(e) => {
                    const page = parseInt(e.target.value);
                    if (page >= 1 && page <= pagination.pages) {
                        setPagination(prev => ({ ...prev, page }));
                    }
                    e.target.value = '';
                }}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
                sur {pagination.pages}
            </span>
        </div>

        {/* Bouton Suivant */}
        <button 
            onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
            disabled={pagination.page === pagination.pages}
            style={{
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                background: pagination.page === pagination.pages ? '#f9fafb' : 'white',
                color: pagination.page === pagination.pages ? '#9ca3af' : '#374151',
                cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            }}
        >
            Suivant
            <ChevronRight style={{ width: '14px', height: '14px' }} />
        </button>
    </div>
)}

{/* Informations de pagination détaillées */}
{pagination.pages > 1 && (
    <div style={{
        padding: '16px 20px',
        backgroundColor: '#f8fafc',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        color: '#6b7280'
    }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Database style={{ width: '16px', height: '16px' }} />
            <span>
                Affichage de {((pagination.page - 1) * pagination.limit) + 1} à {Math.min(pagination.page * pagination.limit, pagination.total)} 
                sur {pagination.total} codes-barres
            </span>
        </div>
        
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            fontSize: '12px'
        }}>
            <span style={{ 
                backgroundColor: '#e5e7eb',
                padding: '2px 6px',
                borderRadius: '4px',
                fontWeight: '500'
            }}>
                {pagination.limit} par page
            </span>
            <span>•</span>
            <span>Page {pagination.page}/{pagination.pages}</span>
        </div>
    </div>
)}

                        {/* Quick Stats Footer */}
                        {barcodes.length > 0 && (
                            <div style={{
                                padding: '16px 20px',
                                backgroundColor: '#f8fafc',
                                borderTop: '1px solid #e5e7eb',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <div style={{ display: 'flex', gap: '24px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <CheckCircle style={{ width: '16px', height: '16px', color: '#059669' }} />
                                        <span style={{ fontSize: '14px', color: '#374151' }}>
                                            {barcodes.filter(b => b.barcodeStatus === 'Available').length} Disponibles
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <Clock style={{ width: '16px', height: '16px', color: '#dc2626' }} />
                                        <span style={{ fontSize: '14px', color: '#374151' }}>
                                            {barcodes.filter(b => b.phase === 'phase2').length} Phase 2
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <Globe style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                        <span style={{ fontSize: '14px', color: '#374151' }}>
                                            {barcodes.filter(b => b.location).length} Localisés
                                        </span>
                                    </div>
                                </div>
                                
                                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                    Last updated: {new Date().toLocaleTimeString('fr-FR')}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            
            {/* Notifications Container */}
            {notifications.length > 0 && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    zIndex: 9999,
                    pointerEvents: 'none'
                }}>
                    <div style={{ pointerEvents: 'auto' }}>
                        {notifications.map(notification => (
                            <NotificationItem
                                key={notification.id}
                                notification={notification}
                                onRemove={removeNotification}
                            />
                        ))}
                    </div>
                </div>
            )}

            {/* Confirm Dialog */}
            {confirmDialog.isOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '400px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            marginBottom: '16px'
                        }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                backgroundColor: '#dc2626',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <AlertCircle style={{ width: '20px', height: '20px', color: 'white' }} />
                            </div>
                            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                                {confirmDialog.title}
                            </h3>
                        </div>
                        
                        <p style={{ 
                            margin: '0 0 24px 0', 
                            fontSize: '14px', 
                            color: '#6b7280',
                            lineHeight: '1.5'
                        }}>
                            {confirmDialog.message}
                        </p>
                        
                        <div style={{
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={closeConfirmDialog}
                                style={{
                                    padding: '10px 20px',
                                    border: '1px solid #d1d5db',
                                    background: 'white',
                                    color: '#374151',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    cursor: 'pointer'
                                }}
                            >
                                Annuler
                            </button>
                            <button
                                onClick={confirmDialog.onConfirm}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    background: '#dc2626',
                                    color: 'white',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    cursor: 'pointer'
                                }}
                            >
                                Confirmer
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </main>
    </div>
    )
}

export default UnitechBarcodingPage;